import { withProcedureWraper } from "../../../../..";
import ProcedureLayout from "../../../../../../../components/layouts/procedure-layout";
import { CreateApplicationForSuspendContractForm } from "../../../../absence-letter/components/create-application-for-suspend-contract";
export const SuspendApplicationTSNCreate = withProcedureWraper(() => {
  return (
    <ProcedureLayout title="Tạo đơn xin tạm hoãn HĐLĐ">
      <CreateApplicationForSuspendContractForm />
    </ProcedureLayout>
  );
});
